import React from "react";
import myImage from "../img/about/myself.jpg";

import awards_2019_dice from "../img/awards/2019-dice.jpg";
import awards_2018_dachshund from "../img/awards/2018-dachshund.jpg";
import activity_youtube_thumbnail from "../img/about/activity-youtube-thumbnail.png";
import activity_coding_hero from "../img/about/activity-coding-hero.png";

import { Carousel } from "react-bootstrap";

class PairReview extends React.Component {
  constructor() {
    super();

    this.reviews = [
      {
        name: "김현*",
        text:
          "페어와 가장 빠르게 친해지고 스스로 성장했던 시간이었습니다. 선미님은 상대방의 얘기를 잘 들어주시는편이고 분위기를 편하게 해주시는분이라서 너무 즐겁게 시간을 보냈습니다. 제 의견도 잘 받아주시고 본인 의견 제시도 잘 해주셔서 불편함없이 진행할 수 있었습니다. 그리고 제가 드라이버 혹은 네비게이터로 헤매고 있을 때 기다려주신 배려에 감사하고 있습니다. 답을 바로 알려주는게 아니라 방향을 `유도`해주셔서 끝까지 포기하지 않고 확실히 이해하고 넘어갈 수 있었습니다. 또한 문제 이해력이 빠르시고 문제를 해결하는 논리도 정확하게 이해하고 있었습니다.  코플릿 문제를 풀면서 요구사항을 빠르게 캐치하고 큰 흐름을 이해하는 모습을 보며 저도 빨리 성장하고 싶다는 생각을 했습니다. 실무에서 만나 같이 코딩하며 같이 성장하고싶은 개발자란 생각이 들었습니다.",
      },
      {
        name: "신예*",
        text:
          "같은 백엔드를 지향하고 계시지만 애정이 가지 않는 html도 열심히 하시는 모습이 상당히 인상적이었습니다..이건 제가 정말 배워야 할 점이라고 생각이 들며 작성하신 코드에 대한 리뷰를 매우 깔끔하게 설명 해주시는 모습 또한 코드에 애착을 가지고 계시는지 느낄수 있었습니다.(아니면 말고요 ^-^ㅋ) 그리고 제가 모자란 부분에 대해서 도움을 요청 드렸을때 분명 피곤하실텐데도불구 하고 개인적인 시간을 활용하셔서 제게 큰 가르침을 주신 부분 아주 매우 땡큐 베리 머치 감사 하며 그랜절을 올립니다.",
      },
      {
        name: "이상*",
        text: `1. 드라이버와 네비게이터 역할을 잘 분배하여 맡은 역할을 잘 수행하셨습니다.
        2. 제가 부족한 점이 많았는데 차근차근 하나씩 설명해 주시고 고차함수를 이해할 수 있도록 도와주었습니다. 진짜 감사했어요. 천사같은 페어님.
        3. 수도코드 작성하는 것과 들여쓰기 하는 방법을 알려주셨고, 코드를 작성할 때 논리적이고 단계적으로 작성할 수 있도록 도와주셨습니다.
        4. 검색도 잘 활용하시고, 검색한 내용을 이해하고 새롭게 적용하는 능력이 탁월하십니다.
        5. 기존에 알고 있는 방식이 아니라 새로운 방식으로도 문제를 해결하기 위해 여러 방면으로 아이디어를 생각하시고 문제를 풀어나가려는 모습이 정말 존경스럽습니다.
        6. 문제를 차근차근 읽고 필요한 코드, 선언할 내용 등을 잘 파악하며 코드를 머릿속으로 생각했을 때 결과값을 바로 알 수 있는 능력을 가지고 계십니다.
        7. 새로운 해결 방식과 지식을 배우려는 열정이 정말 뛰어납니다.
        8. 페어가 답답한 부분도 있었을 텐데, 인내심을 가지고 기다려주시고 모르는 것을 바로 알려주는 것이 아니라 페어가 생각하고 직접 찾아볼 수 있도록 인도하여 주셨습니다. 페어와 함께 성장하려는 마음을 가지고 있음!
        9. 앞으로도 함께 공부하고 싶은 페어입니다. 함께하고 싶은 개발자가 될 거라 믿어 의심치 않습니다.
        10. 페어의 의견을 정말 많이 존중해 주며, 어떠한 아이디어도 그냥 지나치지 않고 시도할 수 있도록 도와주고, 항상 페어의 의견을 묻고 함께 풀려는 마음을 갖고 있습니다.
        11. 가장 이상적인 페어라고 생각합니다.`,
      },
      {
        name: "신예*",
        text: `특훈 덕분에 메소드 만들기에 친숙해졌습니다.
        모자란 부분을 하나씩 모두 꼼꼼하게 잡아주신 덕분에 구상했던 메소드들의 디자인을 모두 완성시킬수 있었네요. 여태 했던 페어분들 중에서 가장 즐거웠고 불태웠으며 최고였습니다. 저와 다르게 백엔드 지향이시면서 프론트엔드 디자인 요소에 애착이 있는점은 정말 존경합니다.`,
      },
      {
        name: "윤어*",
        text: `선미님이 문제를 접근하고 코드를 짜나가는 과정이 효율적이고 creative 한것 같습니다. pair work 내내 저런 생각을 어떻게 하지 하고 많이 놀랐어요 
        또 선미님이 논리적으로 pseudocode 작성하는걸 보고 이렇게 문제를 접근해나가는구나 하는 방향성을 많이 배웠습니다 감사해요 
        그동안 driver 역할을 많이 해왔는데 처음에 Navi/driver를 번갈아 진행하자고 먼저 제안을 해주셔서 반가웠고, 제가 navigator  역할을 하고 struggle 하고 있을때 적절한 방법으로 유도를 도와주어 개념정리하는데 정말 도움이 많이 되었습니다. 
        
        무엇보다 편안한 분위기를 만들어주셔서 덕분에 시간이 어떻게 가는지 모를정도로 즐겁게 공부할수 있었습니다. `,
      },
      {
        name: "오승*",
        text: `일처리 과정이 너무 깔끔해요 정말 많이 배웠어요 수도코드 중요하다고 인지해도  막상 하면 쓰면서 시작하기 바빴는데 좋은 질문으로 제가 무었을 생각해나가야 하는지를 짚어주셔서 조금은 나아진거같아요 . 제가 부족한 부분에서는 역할부분에서도 많이 배려해주셔서 감사하게 생각했습니다. 
        과제를 대할때 그안에서 최대한의 것을 해보려는 태도도 정말 본받아야겠다고 느꼇습니다. `,
      },
      {
        name: "이창*",
        text: `개념들을 문제 없이 설명할 정도로 숙지를 하고 계신 것 같아 네비게이터를 해주실 때 도움이 많이 되었습니다. 이번 페어를 통해 저로선 배울 점이 많아서 적어보았습니다. 수도 코드 적극적으로 사용할 것, 공식 문서와 mdn 영문서 또한 정독하기, 모르는 문제는 더욱 고민해보기 정도로 정리하였습니다. 다소 안이했던 자신을 반성하는 계기가 되었습니다. 감사합니다.`,
      },
      {
        name: "이인*",
        text: `무엇보다 선미님과 함께 이 어려운 스프린트를 함께 했다는 것에 너무나도 감사를 느낍니다. 

        협업, 커뮤니케이션)
        처음에는 office hour 때마다 날카로운 질문을 하는 선미님의 모습에 실력이 대단하고 느끼면서한편으론 차갑겠다고 생각했습니다 ㅋㅎㅎ 그래서 처음 페어할 때 얼마나 떨리던지 ㅠㅠ ㅋㅋ
        
        하지만 어려운 상황에도 오히려 상대방을 칭찬하는 선미님 덕분에 자신없고 헷갈렸던 개념들이 갑자기 떠오를 만큼 큰 힘을 얻었습니다.  선미님은 중요한 포인트를 놓치지 않는 날카로움과 함께하는 사람을 보듬어 주는 따뜻함을 가진 양면적인 이점을 갖고 있어요. 그래서 누구와 페어를 하더라도 좋은 결과를 이끌어 낼 수 있을 만큼의 능력을 가진 분입니다. 
        
        프로그래밍, 실력, 퍼포먼스)
        확실히 그 차이가 다름을 느꼈던 상황이 많았습니다. 
        예를 들어, 어떤 개념을 이해할때 사실에 입각하여 그 의미를 탐색하는 선미님을 보며 정말 많이 배웠습니다. 
        '아~ 프로그래머는 이러한 자세를 가지고 있어야 하는구나.' 하며 이번 스프린트때는 개념의 이해를 넘어 선미님의 모습 하나하나를 배우려고 애썼던 것 같습니다. 진짜 여태까지 만나본 페어 중에 실력 최우수! ㅋㅋ 진짜 객관적으로 그렇게 생각합니다. 여타 코딩 잘하시는 분들 많이 봤지만 선미님을 보니까 '찐 프로그래머' 같았어요 ㅋㅋ 덕분에 어떻게 공부해야 하는지 자알~ 배우고 갑니다!(이 집 코딩 잘하네! ㅋㅋ)
        
        끝으로) 
        선미님과 함께 한 시간동안 많은 것을 배웠고, 얻어갔습니다. 제가 얻어간 만큼 선미님께 돌려드리고 싶었던 부분들이 한편으론 또한 제게 공부가 되어 케미가 맞다는게 느껴졌습니다(저만그런거 아니죠? ㅠ)
        앞으로 함께 해야할 프로젝트가 있는데 또한 우리 재밌게 해요! ㅎㅎ 그리고 제가 실력으로는 뒤쳐진다고 해도 다른 부분에서 함께하는 분들께 받았던 도움을 돌려드리기 위해 계속해서 정진하겠습니다. 
        선미님 우리 꼭 찐(real) 애듀그래머가 되서 이전엔 없었던 새롭고  알찬 컨텐츠와 서비스로 세상을 이롭게 합시닷!`,
      },
      {
        name: "최재*",
        text: `코딩 하는것을 즐기시고 매우 열정적이셔서 그 모습이 제 자신에게도 좋은 자극이 되었습니다.
        항상 긍정적이고 밝게 웃으셔서 좋았습니다.
        스프린트의 베어미니멈 조건에 만족하지 않고, 본인이 만들고 싶은 기능 구현 등 다양한 시도를 해보는게 좋았습니다.
        수도코드 작성을 습관화 하셔서 어려운 로직도 쉽게 풀어내시는 것이 좋았습니다.`,
      },
      {
        name: "조슬*",
        text: `거의 조장님... 같았던 선미님, 처음부터 리드해 주셔서 좋은 시간이 되었던 듯합니다!! 그리고 화려한 언변이라고 해야 하나요....? 갑자기 발표하게 되었을 때도 당황하지 않으시고 곧잘 침착하게 설명 너무 잘해주셔서 멋지게 보였습니다! TMI 지만 저는 많이 떨거든요;; 추후 회사 면접이 너무 걱정되는 부분이라 침착하고 깔끔하게 발표하신 선미님이 너무 부러웠습니다. 선미님은 나중에 면접 걱정 안 하셔도 될 거 같아요! 그리고 코드를 빨리 읽으시고 이해하시는 거 같으세요! 이해하지 못하는 부분도 친절하게 다 설명해 주셔서 감사했습니다 🥰`,
      },
      {
        name: "박단*",
        text: `끝까지 이해하려고 노력하시는 모습이 보기 좋았고, 적극적으로 커뮤니케이션 해주셔서 좋은 분위기로 스프린트 마무리 할수 있었습니다 : )`,
      },
      {
        name: "김노아",
        text: `상대페어의 질문사항에 귀기울여 주셔서 페어프로그래밍을 진행하는데 있어서 할 수 있는 질문들을 상세히 할 수 있었습니다. 페어와 적극적으로 소통하려는 노력이 인상적이였습니다.`,
      },
      {
        name: "이마*",
        text: `문제를 해결하다가 막혔을 때 적극적으로 레퍼런스를 찾는 모습이 인상깊었습니다. 저도 레퍼런스를 찾아보는 연습을 더 많이해야겠다고 생각하게 됐습니다!
        서로 의견에 차이가 있었을 때 제가 이해할 수 있도록 잘 표현해주셔서 감사했습니다!`,
      },
      {
        name: "김지*",
        text: `1.  깔끔한 의사소통
        - 서로 생각을 공유하거나 의견을 나눌때 전혀 문제없음
        2. 해야할 일을 정리하고 하나씩 해결하는 능력에 감탄
        - 과제 진행 전에 무엇을 어떻게 할지에 대한 의논 및 리스트화 시키는 것이 상당히 효율적이고 좋았어요
        3. 상대를 존중한다.
        - 페어 진행 시 서로의 스타일을 이야기하고 합의점을 찾아서 진행해서 인지 부담도 없고 재밋게 할수 있었어요.
        4. 개발에 문제가 발생시 대응법이 좋다
        - 문제가 생겼다고 해서 바로 질문해서 물어보지 않고 우선 혼자 해보겠다고 하시면서 문제를 해결하는 모습이 문제해결에 대한 의지가 좋았어요. 그리고 문제를 잘 해결함.
        
        확실히 알고있던 사이여서 제가 조금 편하게 했던게 불편했을 수 있는데 혹시 있었다면 너그러운 마음으로다가 이해 이해 부탁해요 ㅎ`,
      },

      {
        name: "이정*",
        text: `mysql 마스터하신 갓선미님을 페어로 만나게 되어 매우 영광이였습니다. 저번기수에 여기서 몰래 눈물 훔친 기억이 있어서ㅜ 너무 두려웠었는데 선미님께서 잘 이끌어주신 덕분에 전반적인 과정을 잘 이해할 수 있게 되어 너무너무 기쁩니다. ㅎㅎ 
        논리적인 과정에 매우 흥미를 느끼신다는 선미님의 말씀을 듣고 매우 긍정적인 자극도 받고 항상 유쾌하게 페어 시간 진행해주셔서 감사해여>< 
        에러를 스스로 핸들링 하시는 모습. 정말 인상깊고 멋있었습니다. ㅎㅎ 저는 항상 뭔가 문제가 생기면 헬데부터 올려놓고 시작했는데, 굴하지 않고 해결해 나가는 모습을 보며 저도 좀더 도전의식을 가져야 겠다고 생각했습니다 ㅎㅎ 
        정말 여러모로 감사드리구 계속 승승장구 하시기를 응원합니다!! `,
      },
      {
        name: "강성*",
        text: `사소한 궁금증 하나하나도 놓치지 않으며 메모하고 계속 탐구하시는 모습을 보며 제게는 아직 모자른 부분이라 멋있다고 생각했습니다. 아마 앞으로도 이것이 큰 원동력이 되어 좋은 개발자가 되지 않으실까 생각합니다. 확실히 실력도 좋으셨고 앞서 배웠던 것들을 잘 활용하며, 특히 검색하고 파악해서 적용하는것이 빠르다고 느꼈습니다. 확실히 앞으로도 잘 하실거라고 생각이 됩니다. HA 화이팅이에요!`,
      },
      {
        name: "현승*",
        text: `저와는 다르게 일단 이해하려고 하신 점 되게 높게 생각 하고 있습니다
        저같은 경우에는 하나도 이해가 안가서 일단은 mdn 같은걸 참고하면서 따라 치는 걸
        먼저 하거든요
        
        하지만 선미님은 일단은 이해하려고 노력하신다는 점에 대해서 정말 좋은 점이라고
        생각합니다
        
        되게 간만에 페어프로그래밍 시간이 편하다는 생각이 몇번 없었는데
        선미님 같은 경우에 성격이 좋으셔서 페어프로그래밍 하는 시간이 불편하지
        않았습니다
        
        제가 질문하는 되게 별 영양가 없는 질문에도 친절하게 답변해주시고
        슬랙으로 질문을 해도 친절하게 답변해주시고 정말 감사합니다
        
        선미님이 잘하신 점이 되게 많지만 하나 하나 적으면 되게 길기에
        제일 인상 깊었던 점만 적었습니다
        
        이대로 쭉 가시다 보면 좋은곳에 취직 되실것 같습니다
        이대로 쭉 힘내시고 직진 하시면 될것 같습니다!!`,
      },
      {
        name: "이정*",
        text: `선미님께서 어떻게 생각하실지 모르겠지만, 배재하고 말씀드리면 저는 그동안 했던 페어프로그래밍 중에 가장 유쾌하고 유익했던 시간이였습니다. 시작하기에 앞서 먼저 진행 방법에 대해 질문해주시고 스프린트 도중에 막히는 부분이 생겼을 때 차근차근 질문해주셨으며 제가 눈치가 없어 하찮은 드립에도 잘 웃어주시고 받아주셔서 타이트한 스케줄 속에서도 웃으며 코딩했던 몇 안 되는 시간이였습니다. 막히는 문제가 발생했을 때 공식문서도 꼼꼼히 읽고 잘 적용하는 모습, 긴 시간 동안 집중력이 유지되는 모습, 디버깅하는 방법들 등 이런 모습을 보면서 제 자신도 자극을 불끈 받고 갑니다. 앞으로 남은 일정 잘 준비하셔서 마무리 하셨으면 좋겠습니다! 고생 많으셨고 앞으로도 파이팅! 입니다~~  감사합니당~!.!`,
      },
      {
        name: "이근*",
        text:
          "문제에 대한 다양한 접근법과 이해력이 뛰어나시고 저의 부족한 부분이나 이해가 느린 부분을 이해해주시고 잘 이끌어 주시고 해결이 될 때 까지 지켜봐주시는점이 감명 깊었습니다. ",
      },
      {
        name: "임지*",
        text:
          "도형을 그리면서까지 자세하게 설명해주심 기초가 부족하지만 열심히 하려고 하는 모습에 대해서 좋게 봐주심",
      },
    ];
  }

  render() {
    return (
      <>
        <Carousel>
          {this.reviews.map((review) => (
            <Carousel.Item>
              <div
                style={{
                  width: "100%",
                  height: "300px",
                  background: "rgb(114, 200, 235)",
                }}
              ></div>

              <Carousel.Caption>
                <h5 style={{ textAlign: "left" }}>{review.text}</h5>
                <p> 코드스테이츠 IM25 {review.name}님</p>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </>
    );
  }
}

export default PairReview;
